var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { getCurrentDate, getCalendarPage, dayNames, monthNames, formatDate, isDayWithinRange, isSameDay, isWeekend } from './dateUtils';
import classNames from 'classnames';
import styles from './DatePicker.module.css';
import baseStyles from '../Base.module.css';
export default React.forwardRef(function DatePicker(props, ref) {
    var _a;
    var _b = __read(React.useState(getCurrentDate()), 2), calendarDate = _b[0], setCalendarDate = _b[1];
    var _c = __read(React.useState(false), 2), calendarVisible = _c[0], setCalendarVisible = _c[1];
    var selectedDate = props.selectedDate, endDate = props.endDate, onChange = props.onChange, _d = props.isValid, isValid = _d === void 0 ? true : _d;
    React.useEffect(function () {
        if (selectedDate && endDate && selectedDate > endDate) {
            onChange(new Date(endDate));
        }
    }, [endDate, selectedDate, onChange]);
    React.useEffect(function () {
        setCalendarDate(selectedDate || getCurrentDate());
    }, [selectedDate]);
    var nextMonth = function () {
        var date = new Date(calendarDate);
        date.setDate(1);
        date.setMonth(calendarDate.getMonth() + 1);
        setCalendarDate(date);
    };
    var prevMonth = function () {
        var date = new Date(calendarDate);
        date.setDate(1);
        date.setMonth(calendarDate.getMonth() - 1);
        setCalendarDate(date);
    };
    var hideCalendar = function () {
        setCalendarVisible(false);
        setCalendarDate(selectedDate || getCurrentDate());
    };
    var toggleCalendar = function () {
        if (calendarVisible)
            hideCalendar();
        else
            setCalendarVisible(true);
    };
    var clearDate = function (event) {
        event.stopPropagation();
        setCalendarVisible(false);
        setCalendarDate(getCurrentDate());
        onChange(undefined);
    };
    var createDayElement = function (_a, index) {
        var _b;
        var day = _a.day, currentMonth = _a.currentMonth;
        var calendarDay = new Date(calendarDate.getFullYear(), calendarDate.getMonth(), day);
        var withinRange = props.isDatePeriod
            ? currentMonth
            : currentMonth && isDayWithinRange(calendarDay, new Date(), endDate);
        var className = classNames(styles.day, (_b = {},
            _b[styles.currentMonth] = withinRange,
            _b[styles.weekend] = currentMonth && isWeekend(calendarDay),
            _b[styles.selected] = currentMonth && selectedDate && isSameDay(selectedDate, calendarDay),
            _b));
        var dayProps = { className: className, key: index };
        if (withinRange) {
            dayProps['data-testid'] = "".concat(props.name, "-").concat(day);
            dayProps.onClick = function () {
                onChange(calendarDay);
                hideCalendar();
            };
        }
        return React.createElement("div", __assign({}, dayProps), day);
    };
    var month = calendarDate.getMonth();
    var year = calendarDate.getFullYear();
    var dayElements = getCalendarPage(year, month).map(createDayElement);
    var weekDays = dayNames.map(function (dayName) { return (React.createElement("div", { key: dayName, className: styles.dayName }, dayName)); });
    var calendar = (React.createElement("div", { className: styles.picker, style: props.isDatePeriod ? { right: 0 } : {} },
        React.createElement("div", { className: styles.title },
            React.createElement("div", { className: styles.arrow, onClick: prevMonth }, "\u2190"),
            React.createElement("div", null,
                monthNames[month],
                " ",
                year),
            React.createElement("div", { className: styles.arrow, onClick: nextMonth }, "\u2192")),
        React.createElement("div", { className: styles.calendar }, weekDays.concat(dayElements))));
    var className = classNames(baseStyles.controlInput, styles.input, (_a = {},
        _a[baseStyles.controlInputInvalid] = !isValid,
        _a));
    return (React.createElement("div", { className: styles.outerContainer, ref: ref, tabIndex: 0, onBlur: hideCalendar, onKeyDown: function (event) { return event.key === 'Escape' && hideCalendar(); } },
        React.createElement("div", { className: className, onClick: toggleCalendar, "data-testid": props.name },
            selectedDate ? (formatDate(selectedDate)) : (React.createElement("div", { className: baseStyles.placeholder }, "\u0434\u0434.\u043C\u043C.\u0433\u0433")),
            React.createElement("button", { type: 'button', className: baseStyles.deleteButtonBlack, onClick: clearDate })),
        calendarVisible && calendar,
        props.isValid === false && (React.createElement("div", { className: baseStyles.validationMessage }, props.validationMessage))));
});
